import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import { DailySmsUsageResponse, UpdateSmsUsageBlockPayload } from 'types/smsUsage/smsUsage';

/** `date` is a UTC day (`YYYY-MM-DD`) within today and the previous 30 days; anything else answers 422. */
export const getSmsUsage = (date: string): AxiosPromise<DailySmsUsageResponse> =>
  httpClient({
    method: 'GET',
    url: '/super-admin/sms-usage',
    params: { date },
  });

export const updateSmsUsageBlock = (
  data: UpdateSmsUsageBlockPayload,
): AxiosPromise<{ success: boolean }> =>
  httpClient({
    method: 'PUT',
    url: '/super-admin/sms-usage',
    data,
  });
